import { useState } from "react";
import { useCustom, useCustomMutation } from "@refinedev/core";

import { leesVoorkeur, standaardVoorkeur, type DieroverzichtVoorkeur } from "./tegelDefinities";

const URL = "pension/dieroverzicht-voorkeur";

/**
 * Hoe de ingelogde gebruiker het dieroverzicht wil zien. Per gebruiker bewaard in de api, dus hij
 * volgt je naar een andere browser en overleeft opnieuw inloggen. Zolang hij laadt geldt de standaard,
 * zodat de tegels niet eerst leeg verschijnen.
 */
export function useDieroverzichtVoorkeur() {
  const { data } = useCustom<{ instellingen?: unknown }>({ url: URL, method: "get" });
  const { mutateAsync } = useCustomMutation<{ instellingen?: unknown }>();
  // Na opslaan geldt meteen wat er is bewaard, zonder op een nieuwe GET te wachten.
  const [bewaard, setBewaard] = useState<DieroverzichtVoorkeur | null>(null);

  const voorkeur = bewaard ?? (data?.data?.instellingen ? leesVoorkeur(data.data.instellingen) : standaardVoorkeur());

  const opslaan = async (nieuw: DieroverzichtVoorkeur) => {
    await mutateAsync({
      url: URL,
      method: "put",
      values: { instellingen: nieuw },
      successNotification: false,
      errorNotification: false,
    });
    setBewaard(nieuw);
  };

  return { voorkeur, opslaan };
}
